import Navbar from '../components/Navbar';
import Footer from '../components/Footer';


import React from 'react'

import HeroImg2 from '../components/HeroImg2';
import ABoutContent from '../components/ABoutContent';

const About = () => {
  return (
  <>
     <Navbar/>
     <HeroImg2 heading="ABOUT." text="I m a Front-End Developer." />
     <ABoutContent />

   <Footer />
      
    </>
  )
}

export default About;
